import { render, staticRenderFns } from "./honoraryAwards.vue?vue&type=template&id=c1291994&scoped=true&"
import script from "./honoraryAwards.vue?vue&type=script&lang=js&"
export * from "./honoraryAwards.vue?vue&type=script&lang=js&"
import style0 from "./honoraryAwards.vue?vue&type=style&index=0&id=c1291994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1291994",
  null
  
)

export default component.exports